import React from 'react'
import {Breadcrumbs, Crumb} from './style'
import {useHistory, useRouteMatch} from "react-router-dom";
import { language } from '../../utils/language';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducers/index';


interface IBreadCrumb{
    linkName1? : string, 
    linkroute1? : string, 
    linkName2?:string, 
    linkroute2?:string, 
    currentPage: string
}

const BreadCrumb = ({ linkName1 = "", linkroute1 = "", linkName2="", linkroute2="" , currentPage}: IBreadCrumb ) => {

    const history = useHistory();
    const match:any = useRouteMatch('/vende/:idCatalog')
    const basePath = `/vende/${match.params.idCatalog}`
    const homeState: HomeStateType = useSelector((state: RootState) => state.home)

    const handleHomeRedirect = ()=>{
        history.push(`${basePath}/`)
    }

    const handleRedirect = (route: string )=>{
        history.push(`/${route}`)
    }


    return (
            <Breadcrumbs>
                <Crumb>
                    <a onClick={handleHomeRedirect}>{language[homeState.default_language]["home"]}</a>
                </Crumb>
                {
                    (linkName1 !=="" && linkroute1 !=="") &&
                    <Crumb>
                        <a onClick={() => handleRedirect(linkroute1)}>{linkName1}</a>
                    </Crumb>

                }
                {
                    (linkName2 !=="" && linkroute2 !=="") &&
                    <Crumb>
                        <a onClick={() => handleRedirect(linkroute2)}>{linkName2}</a>
                    </Crumb>

                }
                <Crumb>{currentPage}</Crumb>
            </Breadcrumbs>
    )
}

export default BreadCrumb